var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeo4J(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "algorithms-and-data-structures/data-structures/graphs"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    id: "algorithms-and-data-structures/data-structures/graphs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#373737",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "connection",
    transform: "translate(14.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.285156, 2.285156)",
    fill: "#EF2648"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "1.42584961 39.9518262 0.0038671875 39.477832 5.20505859 23.8710937 3.63761719 3.49505859 23.0768262 8.16082031 35.5575586 0.0856054687 36.3721289 1.34411133 23.3528027 9.76886719 5.29207031 5.43462891 6.72459961 24.0585645 6.67582031 24.2018262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(31.463959, 9.716748) rotate(95.192354) translate(-31.463959, -9.716748) ",
    x: 30.7139415,
    y: 1.43293968,
    width: 1.50003459,
    height: 16.5676171
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(8.589266, 31.841868) rotate(161.566863) translate(-8.589266, -31.841868) ",
    x: 7.83964139,
    y: 23.5392655,
    width: 1.49924887,
    height: 16.6052052
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "18.3083203 33.0916113 14.9820996 18.1276172 16.4475879 17.8020703 19.1213086 29.8380762 27.1456348 20.476582 28.284082 21.4531348"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    transform: "translate(27.343357, 33.719111) rotate(104.619910) translate(-27.343357, -33.719111) ",
    x: 26.5934033,
    y: 24.8057492,
    width: 1.49990805,
    height: 17.8267227
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B7E5FF",
    cx: 6.75,
    cy: 6.75,
    r: 6.0000293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1737793,1.8262793 C12.0667676,4.54350586 11.3977441,8.28079102 8.68051758,10.1737793 C6.62097656,11.6085059 3.88573242,11.6085059 1.8262793,10.1737793 C3.71100586,12.8992676 7.44829102,13.5810352 10.1737793,11.6970117 C12.8992676,9.81298828 13.5810352,6.075 11.6970117,3.34951172 C11.2852441,2.75396484 10.7692383,2.23795898 10.1737793,1.8262793 Z",
    id: "Shape",
    fill: "#99C8E0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B7E5FF",
    cx: 38.25,
    cy: 38.25,
    r: 6.0000293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6737793,33.3262793 C43.5667676,36.0435059 42.8977441,39.780791 40.1805176,41.6737793 C38.1209766,43.1085059 35.3857324,43.1085059 33.3262793,41.6737793 C35.2110059,44.3992676 38.948291,45.0810352 41.6737793,43.1970117 C44.3992676,41.3129883 45.0810352,37.575 43.1970117,34.8495117 C42.7852441,34.2539648 42.2692383,33.737959 41.6737793,33.3262793 Z",
    id: "Shape",
    fill: "#99C8E0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4DB5FF",
    cx: 20.9999707,
    cy: 33.75,
    r: 3.7500293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2410059,30.7589941 C24.4874707,32.4022852 24.165791,34.7444824 22.523291,35.9910352 C21.1890234,37.0035352 19.3433203,37.0035352 18.0090527,35.9910352 C19.2412793,37.6485645 21.5835645,37.9935352 23.2410937,36.7620117 C24.898623,35.5297852 25.2435937,33.1875 24.0120703,31.5299707 C23.79375,31.2367676 23.534209,30.9765234 23.2410059,30.7589941 Z",
    id: "Shape",
    fill: "#3596D8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4DB5FF",
    cx: 8.2500293,
    cy: 26.2500293,
    r: 3.7500293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4909766,23.2590234 C11.7374414,24.9023145 11.4157617,27.2445117 9.77326172,28.4910645 C8.43899414,29.5035645 6.59329102,29.5035645 5.25902344,28.4910645 C6.49125,30.1485937 8.83353516,30.4935645 10.4910645,29.262041 C12.1485937,28.0298145 12.4935645,25.6875293 11.262041,24.03 C11.0437207,23.736709 10.7842676,23.4764648 10.4909766,23.2590234 Z",
    id: "Shape",
    fill: "#3596D8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4DB5FF",
    cx: 25.4999707,
    cy: 11.25,
    r: 3.7500293
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7410059,8.25899414 C28.9874707,9.90228516 28.665791,12.2444824 27.023291,13.4910352 C25.6890234,14.5035352 23.8433203,14.5035352 22.5090527,13.4910352 C23.7412793,15.1485645 26.0835645,15.4935352 27.7410937,14.2620117 C29.398623,13.0297852 29.7435937,10.6875 28.5120703,9.0299707 C28.29375,8.73676758 28.034209,8.47652344 27.7410059,8.25899414 Z",
    id: "Shape",
    fill: "#3596D8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 2.9999707,
    cy: 42.0000293,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16548828,40.084541 C4.38301758,40.4347852 4.49850586,40.838291 4.5,41.2500586 C4.5,42.492832 3.49277344,43.5000586 2.25,43.5000586 C1.83823242,43.4985645 1.43472656,43.3830762 1.08448242,43.1655469 C1.72494141,44.2260352 3.105,44.5665234 4.16548828,43.9260645 C5.22597656,43.2856055 5.56646484,41.9055469 4.92600586,40.8450586 C4.73774414,40.53375 4.47670898,40.2727148 4.16548828,40.084541 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 13.5,
    cy: 42.0000293,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6655176,40.084541 C14.8830469,40.4347852 14.9985352,40.838291 15.0000293,41.2500586 C15.0000293,42.492832 13.9928027,43.5000586 12.7500293,43.5000586 C12.3382617,43.4985645 11.9347559,43.3830762 11.5845117,43.1655469 C12.2249707,44.2260352 13.6050293,44.5665234 14.6655176,43.9260645 C15.7260059,43.2856055 16.0664941,41.9055469 15.4260352,40.8450586 C15.2377734,40.53375 14.9767383,40.2727148 14.6655176,40.084541 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 18,
    cy: 20.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1655176,18.3345117 C19.3830469,18.6847559 19.4985352,19.0882617 19.5000293,19.5000293 C19.5000293,20.7428027 18.4928027,21.7500293 17.2500293,21.7500293 C16.8382617,21.7485352 16.4347559,21.6330469 16.0845117,21.4155176 C16.7249707,22.4760059 18.1050293,22.8164941 19.1655176,22.1760352 C20.2260059,21.5355762 20.5664941,20.1555176 19.9260352,19.0950293 C19.7377734,18.7837207 19.4767383,18.5227734 19.1655176,18.3345117 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 29.9999707,
    cy: 23.2499707,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1654883,21.3344824 C31.3830176,21.6847266 31.4985059,22.0882324 31.5,22.5 C31.5,23.7427734 30.4927734,24.75 29.25,24.75 C28.8382324,24.7485059 28.4347266,24.6330176 28.0844824,24.4154883 C28.7249414,25.4759766 30.105,25.8164648 31.1654883,25.1760059 C32.2259766,24.5355469 32.5664648,23.1554883 31.9260059,22.095 C31.7377441,21.7837793 31.476709,21.5227441 31.1654883,21.3344824 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 42.0000293,
    cy: 12.7500293,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1655469,10.834541 C43.3830762,11.1847852 43.4985645,11.588291 43.5000586,12.0000586 C43.5000586,13.242832 42.492832,14.2500586 41.2500586,14.2500586 C40.838291,14.2485645 40.4347852,14.1330762 40.084541,13.9155469 C40.725,14.9760352 42.1050586,15.3165234 43.1655469,14.6760645 C44.2260352,14.0356055 44.5665234,12.6555469 43.9260645,11.5950586 C43.7377148,11.28375 43.4767676,11.0227148 43.1655469,10.834541 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#235087",
    cx: 38.25,
    cy: 2.9999707,
    r: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4155176,1.08448242 C39.6330469,1.43472656 39.7485352,1.83823242 39.7500293,2.25 C39.7500293,3.49277344 38.7428027,4.5 37.5000293,4.5 C37.0882617,4.49850586 36.6847559,4.38301758 36.3345117,4.16548828 C36.9749707,5.22597656 38.3550293,5.56646484 39.4155176,4.92600586 C40.4760059,4.28554687 40.8164941,2.90548828 40.1760352,1.845 C39.9877734,1.5337793 39.7267383,1.27274414 39.4155176,1.08448242 Z",
    id: "Shape",
    fill: "#163768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,13.5 C3.02176758,13.5 0,10.4782324 0,6.75 C0,3.02176758 3.02176758,0 6.75,0 C10.4782324,0 13.5,3.02176758 13.5,6.75 C13.4955176,10.4760352 10.4760352,13.4955176 6.75,13.5 Z M6.75,1.5000293 C3.85048828,1.5000293 1.5000293,3.85048828 1.5000293,6.75 C1.5000293,9.64951172 3.85048828,11.9999707 6.75,11.9999707 C9.64951172,11.9999707 11.9999707,9.64951172 11.9999707,6.75 C11.9969824,3.85198242 9.64801758,1.50301758 6.75,1.5000293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25,6.0000293 C36.5932617,6.0000293 35.2500293,4.65679688 35.2500293,3.00005859 C35.2500293,1.34332031 36.5932617,0 38.25,0 C39.9067383,0 41.2499707,1.34323242 41.2499707,2.9999707 C41.2499707,4.65670898 39.9067383,6.0000293 38.25,6.0000293 Z M38.25,1.5000293 C37.4212793,1.5000293 36.7499707,2.17125 36.7499707,3.00005859 C36.7499707,3.82886719 37.4212793,4.5 38.25,4.5 C39.0787207,4.5 39.7500293,3.8287793 39.7500293,2.9999707 C39.7500293,2.17116211 39.0787207,1.5000293 38.25,1.5000293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4999707,15.75 C23.0145117,15.75 20.9999707,13.735459 20.9999707,11.25 C20.9999707,8.76454102 23.0145117,6.75 25.4999707,6.75 C27.9854297,6.75 29.9999707,8.76454102 29.9999707,11.25 C29.9977734,13.7339648 27.9840234,15.7477148 25.4999707,15.75 Z M25.4999707,8.2500293 C23.8432324,8.2500293 22.5,9.59326172 22.5,11.25 C22.5,12.9067383 23.8432324,14.2499707 25.4999707,14.2499707 C27.156709,14.2499707 28.4999414,12.9067383 28.4999414,11.25 C28.4999414,9.59326172 27.156709,8.2500293 25.4999707,8.2500293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0000293,15.75 C40.343291,15.75 39.0000586,14.4067676 39.0000586,12.7500293 C39.0000586,11.093291 40.343291,9.75005859 42.0000293,9.75005859 C43.6567676,9.75005859 45,11.093291 45,12.7500293 C45,14.4067676 43.6567676,15.75 42.0000293,15.75 Z M42.0000293,11.25 C41.1713086,11.25 40.5,11.9212207 40.5,12.7500293 C40.5,13.57875 41.1712207,14.2500586 42.0000293,14.2500586 C42.82875,14.2500586 43.5000586,13.5788379 43.5000586,12.7500293 C43.4999707,11.9212207 42.82875,11.25 42.0000293,11.25 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.25,45 C34.5217676,45 31.5,41.9782324 31.5,38.25 C31.5,34.5217676 34.5217676,31.5 38.25,31.5 C41.9782324,31.5 45,34.5217676 45,38.25 C44.9955176,41.9760352 41.9760352,44.9955176 38.25,45 Z M38.25,33.0000293 C35.3504883,33.0000293 33.0000293,35.3504883 33.0000293,38.25 C33.0000293,41.1495117 35.3504883,43.4999707 38.25,43.4999707 C41.1495117,43.4999707 43.4999707,41.1495117 43.4999707,38.25 C43.4969824,35.3519824 41.1480176,33.0030176 38.25,33.0000293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2500293,30.7500293 C5.76457031,30.7500293 3.7500293,28.7354883 3.7500293,26.2500293 C3.7500293,23.7645703 5.76457031,21.7500293 8.2500293,21.7500293 C10.7354883,21.7500293 12.7500293,23.7645703 12.7500293,26.2500293 C12.7477441,28.7339941 10.7339941,30.7477441 8.2500293,30.7500293 Z M8.2500293,23.2499707 C6.59329102,23.2499707 5.25005859,24.5932031 5.25005859,26.2499414 C5.25005859,27.9066797 6.59329102,29.25 8.2500293,29.25 C9.90676758,29.25 11.25,27.9067676 11.25,26.2500293 C11.25,24.593291 9.90676758,23.2499707 8.2500293,23.2499707 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9999707,45 C1.34323242,45 0,43.6567676 0,42.0000293 C0,40.343291 1.34323242,39.0000586 2.9999707,39.0000586 C4.65670898,39.0000586 5.99994141,40.343291 5.99994141,42.0000293 C5.99994141,43.6567676 4.65670898,45 2.9999707,45 Z M2.9999707,40.5 C2.17125,40.5 1.49994141,41.1712207 1.49994141,42.0000293 C1.49994141,42.82875 2.17116211,43.5000586 2.9999707,43.5000586 C3.8287793,43.5000586 4.5,42.82875 4.5,42.0000293 C4.5,41.1712207 3.8287793,40.5 2.9999707,40.5 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999707,38.25 C18.5145117,38.25 16.4999707,36.235459 16.4999707,33.75 C16.4999707,31.264541 18.5145117,29.25 20.9999707,29.25 C23.4854297,29.25 25.4999707,31.264541 25.4999707,33.75 C25.4977734,36.2339648 23.4840234,38.2477148 20.9999707,38.25 Z M20.9999707,30.7500293 C19.3432324,30.7500293 18,32.0932617 18,33.75 C18,35.4067383 19.3432324,36.7499707 20.9999707,36.7499707 C22.656709,36.7499707 24.0000293,35.4067383 24.0000293,33.75 C24.0000293,32.0932617 22.656709,30.7500293 20.9999707,30.7500293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,23.2499707 C16.3432617,23.2499707 15.0000293,21.9067383 15.0000293,20.25 C15.0000293,18.5932617 16.3432617,17.2500293 18,17.2500293 C19.6567383,17.2500293 20.9999707,18.5932617 20.9999707,20.25 C20.9999707,21.9067383 19.6567383,23.2499707 18,23.2499707 Z M18,18.7499707 C17.1712793,18.7499707 16.4999707,19.4211914 16.4999707,20.25 C16.4999707,21.0787207 17.1711914,21.7500293 18,21.7500293 C18.8287207,21.7500293 19.5000293,21.0788086 19.5000293,20.25 C19.5000293,19.4212793 18.8287207,18.7499707 18,18.7499707 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999707,26.2500293 C28.3432324,26.2500293 27,24.9067969 27,23.2500586 C27,21.5933203 28.3432324,20.2500879 29.9999707,20.2500879 C31.656709,20.2500879 32.9999414,21.5933203 32.9999414,23.2500586 C32.9999414,24.9067969 31.656709,26.2500293 29.9999707,26.2500293 Z M29.9999707,21.7500293 C29.17125,21.7500293 28.4999414,22.42125 28.4999414,23.2500586 C28.4999414,24.0787793 29.1711621,24.7500879 29.9999707,24.7500879 C30.8286914,24.7500879 31.5,24.0788672 31.5,23.2500586 C31.5,22.42125 30.8287793,21.7500293 29.9999707,21.7500293 Z",
    id: "Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,45 C11.8432617,45 10.5000293,43.6567676 10.5000293,42.0000293 C10.5000293,40.343291 11.8432617,39.0000586 13.5,39.0000586 C15.1567383,39.0000586 16.4999707,40.343291 16.4999707,42.0000293 C16.4999707,43.6567676 15.1567383,45 13.5,45 Z M13.5,40.5 C12.6712793,40.5 11.9999707,41.1712207 11.9999707,42.0000293 C11.9999707,42.82875 12.6711914,43.5000586 13.5,43.5000586 C14.3287207,43.5000586 15.0000293,42.8288379 15.0000293,42.0000293 C15.0000293,41.1712207 14.3287207,40.5 13.5,40.5 Z",
    id: "Shape",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo4J);
export default __webpack_public_path__ + "static/media/neo4j.5563f9d3c25cf97b5d56de76a88dd987.svg";
export { ForwardRef as ReactComponent };